// @flow @format
import React, {PureComponent, type ComponentType} from 'react';

import type {FileNode} from 'lib/cloner-api';

type CacheState = {
	fileNode: ?FileNode,
};

/**
 * HOC that stores and forwards the latest non nil fileNode that WrappedComponent
 * receive as props.
 *
 * e.g. const KomponentWithCache = withFileNodeCache(Komponent);
 */
function withFileNodeCache<Props: CacheState>(
	WrappedComponent: ComponentType<Props>
) {
	return class extends PureComponent<Props, CacheState> {
		state = {
			fileNode: null,
		};

		componentWillMount() {
			const {fileNode} = this.props;
			this.setState({fileNode});
		}

		componentWillReceiveProps(nextProps: Props) {
			const {fileNode} = nextProps;
			if (fileNode) {
				this.setState({fileNode});
			}
		}

		render() {
			return <WrappedComponent {...this.props} {...this.state} />;
		}
	};
}

export default withFileNodeCache;



// WEBPACK FOOTER //
// ./src/routes/Explorer/hoc/withFileNodeCache.js